import ManageColumns from './ManageColumns.component';

export default ManageColumns;
